export default [
    { value: 'fecha' },
    { value: 'hora' },
    { value: 'codigo_autorizacion' },
    { value: 'terminal' },
    { value: 'tipo' },
    { value: 'num_operacion', format: 'number' },
    { value: 'monto', format: 'currency' },
    { value: 'cuotas', format: 'number' },
    { value: 'monto_cuota', format: 'currency' },
    { value: 'comision', format: 'currency' },
    { value: 'total_pago', format: 'currency' },
].map(({ value, format }) => ({
    value: value,
    text: value
        .split('_')
        .join(' ')
        .toUpperCase(),
    format: format || null,
    sortable: true,
}))
